module.exports = __webpack_public_path__ + "img/banner_recommend.22d857d6.jpg";